// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6DypV","inner":"styles_inner__1PStk","right":"styles_right__1auhB","close":"styles_close__3d4Dz","footer":"styles_footer__I8uy8"};